import '../../../utils/index.mjs';
import { radioPropsBase } from './radio.mjs';
import { buildProps } from '../../../utils/vue/props.mjs';

const radioButtonProps = buildProps({
  ...radioPropsBase,
  name: {
    type: String,
    default: ""
  }
});

export { radioButtonProps };
//# sourceMappingURL=radio-button.mjs.map
